import { createGetEnvVar } from '@hopin-team/dashboard-constants';
import React from 'react';
import { Helmet } from 'react-helmet';

interface ConsentProviderProps {
  children: React.ReactNode;
}

const DISABLE_COOKIE_CONSENT = 'DISABLE_COOKIE_CONSENT';
const getConsentDisabled = createGetEnvVar(
  {
    local: 'enabled',
    staging: 'enabled',
    review: 'enabled',
    production: 'enabled',
  },
  'disable-cookie-consent',
);

export const TrackingConsentProvider: React.FC<ConsentProviderProps> = ({
  children,
}) => {
  if (getConsentDisabled() === DISABLE_COOKIE_CONSENT) return <>{children}</>;

  return (
    <>
      <Helmet>
        <script
          src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
          type="text/javascript"
          async
          data-domain-script="6ac561ff-e2a0-4962-abc5-fc5fab405159"
        ></script>
        <script>{`
function OptanonWrapper() {
  const consentUpdatedEvent = new CustomEvent('consent_updated', {
    detail: {
      analytics: window.OnetrustActiveGroups?.includes('C0004') ? 'ACCEPT' : 'DENY'
    },
  });
  window.dispatchEvent(consentUpdatedEvent);

  window.OneTrust?.OnConsentChanged(function () {
    window.dispatchEvent(consentUpdatedEvent);
  });
}
        `}</script>
      </Helmet>
      {children}
    </>
  );
};
